/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Heading } from '@msdyn365-commerce-modules/utilities';
import { IMfrmProductsCompareViewProps } from './mfrm-products-compare';
import { RichTextComponent } from '@msdyn365-commerce/core';
import Carousel from 'mfcl/Carousel';

export default (props: IMfrmProductsCompareViewProps) => {

    const { mattributeHeadings, carouselItems, onCurrentCardClick, onOtherCardClick, compareRef, isDesktop, collectionDescription } = props;
    const { sleepExpertModuleSlot } = props.slots;
    if (!carouselItems?.length) {
        props.context.telemetry.error('Product Compare is empty, module wont render.');
        return null;
    }
    const mattributeIcons = props.data.productBenefitsData.result;
    return (
        <div className='product-compare' ref={compareRef}>
            <div className='product-compare__header'>
                <Heading className='product-compare__header-heading' {...props.config.heading} text="Compare the Collection" />
                <RichTextComponent
                    className='product-compare__header-description'
                    text={collectionDescription ?? props.config.description ?? ''}
                />
            </div>
            <div className='product-compare__content'>
                <div className='product-compare__content-left'>
                    <div className='collection-specification'>
                        <ul>
                            <li className='collection-specification__item'>Price</li>
                            <li className='collection-specification__item'>Deliver By</li>
                            <li className='collection-specification__item'>Comfort</li>
                            <li className='collection-specification__item'>Best For</li>
                            <li className='collection-specification__item'>Mattress Type</li>
                            <li className='collection-specification__item'>Height</li>
                        </ul>
                    </div>
                    <div className='mattribute_headings'>
                        <ul>
                            {mattributeHeadings.map((heading) =>
                            (<li key={heading} className="mattribute_headings__item">
                                <img src={mattributeIcons && mattributeIcons[heading]?.icon} alt={`${heading} icon`} className='mattribute-icon' />
                                <span className='mattribute-name'>{heading}</span>
                            </li>)
                            )}
                        </ul>
                    </div>
                </div>
                <div className='product-compare__content-current-product' onClick={() => onCurrentCardClick()}>
                    {carouselItems && carouselItems[0]}
                </div>
                <div className='product-compare__content-right' onClick={() => onOtherCardClick()}>
                    {isDesktop ? <Carousel
                        ariaLabel="two"
                        layoutGap={7}
                        controlStyle="legacy"
                        variableWidth={true}
                        controlAlignment="top right"
                        controlClass="mfcl-carousel__button-position"
                        itemsToShow={2}
                        hideIndicators
                        disableEndButtons
                        hideControls={true}
                        disableControls={true}
                    >
                        {carouselItems && carouselItems.length > 1 && carouselItems.slice(1)}
                    </Carousel>
                        :
                        carouselItems && carouselItems.length > 1 &&  carouselItems.slice(1).map((item) => {
                            return item;
                        })}
                </div>
            </div>
            <div className='product-compare__sleep-expert'>{sleepExpertModuleSlot}</div>
        </div>
    );
};
